module.exports = __webpack_public_path__ + "img/video.4687c26b.svg";